import React, { Suspense } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { LanguageGlobeIcon, languages } from "./common";
import { type LanguageSelectorProps } from "./language-selector";

// @ts-expect-error
const Selector = React.lazy(() => import("./language-selector"));

const containerStyles = css({
    color: "#42526e",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center"
});

const labelStyles = css({
    marginInlineStart: token("space.050"),
    fontSize: "0.875rem"
});

const arrowStyles = css({
    marginInlineStart: token("space.050"),
    fontSize: "1.5rem"
});

const SelectorFallback = ({
    selectedLanguage = "en"
}: {
    selectedLanguage?: string;
}) => {
    return (
        <div css={containerStyles}>
            <LanguageGlobeIcon color={"#42526e"} />
            <span css={labelStyles}>
                {
                    languages.find(
                        (language) => language.value === selectedLanguage
                    )?.label
                }
            </span>
            <span css={arrowStyles} aria-hidden="true">
                ▾
            </span>
        </div>
    );
};

export const LanguageSelector = (props: LanguageSelectorProps) => (
    <>
        <Suspense
            fallback={
                <SelectorFallback selectedLanguage={props.selectedLanguage} />
            }
        >
            <Selector {...props} />
        </Suspense>
    </>
);
